import Lobby from './Lobby/Lobby.view'
import ChooseDevicePage from './ChooseDevice/ChooseDevice.view';
import Participant from './Participant/Participant.view'
import Chat from './Chat/Chat.view'

export const Views = {
    Lobby,
    ChooseDevicePage,
    Participant,
    Chat,
}